export class ArrayUtils {
  public static uniqueBy<T extends object>(array: T[], prop: keyof T) {
    const seen = new Set();
    return array.filter(item => {
      const key = item[prop];
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  }

  public static unique<T>(array: T[]) {
    return [...new Set(array)];
  }

  public static areEqual<T>(a: T[], b: T[]) {
    if (a.length !== b.length) return false;
    return a.every(item => b.includes(item)) && b.every(item => a.includes(item));
  }

  public static findLastIndex<T>(
    array: T[],
    predicate: (value: T, index: number, obj: T[]) => boolean,
  ): number {
    for (let i = array.length - 1; i >= 0; i--) {
      if (predicate(array[i], i, array)) {
        return i;
      }
    }
    return -1;
  }
}
